// extracted by mini-css-extract-plugin
export default {"solutionItem":"solution-item_solutionItem__hGbXA","header":"solution-item_header__E8H8c","description":"solution-item_description__Il-iP","readMore":"solution-item_readMore__YNKna"};